import React from "react";
import "./news.scss";
import historyImage from "../../images/news-page/history-img.png";
const News = () => {
    return (
        <div className="page-content__container">
            <div className="news">
                <img src={historyImage} alt="history" />
            </div>
        </div>
    );
};

export default News;
